import store from '../../store';
import BasePerimeter from './base';

export default new BasePerimeter({
    purpose: 'campaigns',
    govern: {
        'can view': function () {
            return (this.isSuperAdmin() || this.isAdmin() || this.isAgencyAdmin() || this.isAgencyUser())
        },
        'can viewPrices': function () {
            return (!this.isAgencyUser())
        },
        'can viewUsedAudience': function () {
            const hasAudienceFeature = store.getters.getFeatures && store.getters.getFeatures.audience && store.getters.getFeatures.audience === true;

            return hasAudienceFeature && (this.isClientAdmin() || this.isAgencyAdmin());
        },
    }
});
